
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 26 30","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"26","height":"30","data-name":"Vector Smart Object","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAeCAQAAACY0sZTAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkBwcLFh/zM0BeAAABUklEQVQ4y+2Tv0tCURTHP/cliooILdVQLk5Ckn9AYHMUb2poEm0K/R/6H4ymjKaGJqnFrSBxrKB/oAgyAn9hJoa906Dv8vS9KZcGz13OOV8+fM+53KsEHUWCHOAdp/Qp6ErsE5eWtCUheJyENKUjcbtW2umEHkOWyHr4nPFGmACHk05+6cqarEhPQi6fkHzKssSkK/5RxzdmIyg+sBgQ5WvKJ8o3LRSKCA1AQw0qPGBRo+4ark6NewwqIwTHTgYlFDl+PHZaoISQw3JCUQr4SAO3WBzTdACL5DHG2pAiHTAASJEHqlSBLMkJlyRZreVJOXd652icpV3DPWvNtDf5Q8yhWSAljwSJEbCfCAYDXumxCdwRZnVKe6GvZIMt9rnUnhZ7XHPFE7DOLjtT2gU3CGJKeeL/lCWj84xLM+W/394cmgXyAV22aTt6Yc513nZpRfgFEyunSede3kAAAAAASUVORK5CYII="}})])
          )
        }
      }
    